import { Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function BulkBar({ count, total, canSelectAll, onSelectAll, onClear, onDelete, testPrefix }) {
  if (!count) return null;
  return (
    <div className="sticky top-2 z-20 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 mb-4 shadow-sm fade-up" data-testid={`${testPrefix}-bulk-bar`}>
      <span className="text-sm font-semibold text-rose-900" data-testid={`${testPrefix}-selected-count`}>{count} selected</span>
      {canSelectAll && (
        <button type="button" onClick={onSelectAll} className="text-sm font-semibold text-sky-700 hover:underline" data-testid={`${testPrefix}-select-all-matching`}>
          Select all {total} matching
        </button>
      )}
      <button type="button" onClick={onClear} className="inline-flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground" data-testid={`${testPrefix}-clear-selection`}>
        <X className="h-3.5 w-3.5" />Clear selection
      </button>
      <Button size="sm" onClick={onDelete} className="ml-auto h-9 rounded-lg bg-rose-600 hover:bg-rose-700" data-testid={`${testPrefix}-delete-selected`}>
        <Trash2 className="h-4 w-4 mr-1" />Delete selected
      </Button>
    </div>
  );
}

export function BulkDeleteDialog({ open, title, busy, onCancel, onConfirm, testPrefix }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-card rounded-2xl" data-testid={`${testPrefix}-bulk-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={`${testPrefix}-bulk-dialog-title`}>{title}</AlertDialogTitle>
          <AlertDialogDescription>Deleted items are removed from every total, report and export.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testPrefix}-bulk-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction disabled={busy} onClick={(e) => { e.preventDefault(); onConfirm(); }} className="bg-rose-600 hover:bg-rose-700" data-testid={`${testPrefix}-bulk-confirm`}>
            {busy ? "Deleting…" : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
